module.exports = __webpack_public_path__ + "static/media/infobip.fc74ac89.svg";